import { atom, selector } from "recoil";
import config from "../config";
import Cookies from "js-cookie";

export const selectedLang = atom({
  key: "selectedLang",
  default: { name: "English", code: "en" },
});

export const testResult = atom({
  key: "testResult",
  default: selector({
    key: "testResultSelector",
    get: () => {
      const usernameCookie = Cookies.get("username", {
        domain: config.cookieDomain,
      });
      let user = JSON.parse(localStorage.getItem("user"));
      let resultFromLocalStorage;
      if (user && usernameCookie in user) {
        resultFromLocalStorage = user[usernameCookie]?.result;
      }
      console.log(resultFromLocalStorage);
      if (resultFromLocalStorage) {
        return resultFromLocalStorage;
      }
      return {};
    },
  }),
});

export const isAuthorized = atom({
  key: "isAuthorized",
  default: false,
});

export const isPaid = atom({
  key: "isPaid",
  default: false,
});

export const isReviewSubmitted = atom({
  key: "isReviewSubmitted",
  default: false,
});

export const feedbackSubmittedState = atom({
  key: "feedbackSubmittedState",
  default: false,
});

export const feedbackStatusLoadedState = atom({
  key: "feedbackStatusLoadedState",
  default: false,
});

export const isLoginLoader = atom({
  key: "isLoginLoader",
  default: false,
});

export const languageSelectionModal = atom({
  key: "languageSelectionModal",
  default: false,
});

export const pathState = atom({
  key: "pathState",
  default: "student"
});

export const courseAmount = selector({
  key: "courseAmount",
  get: async () => {
    const fallbackCourseAmount = {
      currency_code: "INR",
      amount: "50.00",
      original_amount: "100.00",
    };

    try {
      const response = await fetch(`${config.nodeDomain}/payment/amount`, {
        method: "GET",
      });

      const rawText = await response.text();
      let res1;

      try {
        res1 = JSON.parse(rawText);
      } catch (error) {
        console.error("Invalid payment amount response:", rawText);
        return fallbackCourseAmount;
      }

      return res1?.status === "success"
        ? res1.data
        : fallbackCourseAmount;
    } catch (error) {
      console.error("Failed to load course amount:", error);
      return fallbackCourseAmount;
    }
  },
});

export const redeemedAmount = atom({
  key: "redeemedAmount",
  default: selector({
    key: "redeemedAmountSelector",
    get: ({ get }) => {
      let courseDetails = get(courseAmount);
      return courseDetails?.amount;
    },
  }),
});

export const couponCode = atom({
  key: "couponCode",
  default: null,
});

export const questionsArray = atom({
  key: "questionsArray",
  default: selector({
    key: "questionsArraySelector",
    get: () => {
      let questions = JSON.parse(localStorage.getItem("questions"));
      if (questions) return questions;
      return [];
    },
  }),
});

export const resultSelector = selector({
  key: "resultSelector",
  get: async ({ get }) => {
    const _selectedLang = get(selectedLang)?.code;
    let user = JSON.parse(localStorage.getItem("user"));
    const userEmail = Cookies.get("email", { domain: config.cookieDomain });
    console.log(user, "userrr");
    console.log(userEmail, "userEmailll");
    if (user && userEmail in user) {
      if (_selectedLang in user[userEmail]) {
        let resultFromLocalStorage = user[userEmail][_selectedLang];
        if (resultFromLocalStorage) {
          return resultFromLocalStorage;
        }
      } else {
        try {
          const response = await fetch(config.domain + `/results?lang=en`, {
            method: "GET",
            credentials: "include",
          });
          const res1 = await response.json();
          console.log(res1, "result res1");
          const userDetails = {
            [userEmail]: {
              ...user[userEmail],
              [res1.data?.lang]: res1.data,
            },
          };
          localStorage.setItem("user", JSON.stringify(userDetails));
          return res1.data;
        } catch (error) {
          throw error; // This will propagate to React Suspense or useRecoilValueLoadable
        }
      }
    } else {
      try {
        const response = await fetch(config.domain + `/results?lang=en`, {
          method: "GET",
          credentials: "include",
        });
        const res1 = await response.json();
        console.log(res1, "result res2");
        const userDetails = {
          [userEmail]: {
            [res1.data?.lang]: res1.data,
          },
        };
        localStorage.setItem("user", JSON.stringify(userDetails));
        return res1.data;
      } catch (error) {
        throw error; // This will propagate to React Suspense or useRecoilValueLoadable
      }
    }
  },
});

export const promptedState = atom({
  key: "promptedState",
  default: false,
});

export const selectedPromptState = atom({
  key: "selectedPromptState",
  default: "",
});

export const setSearchTermState = atom({
  key: "setSearchTermState",
  default: "",
});

export const sidebarOpenState = atom({
  key: "sidebarOpenState",
  default: true,
});

export const detailedResultState = atom({
  key: "detailedResultState",
  default: {},
});
